import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }
  static getDerivedStateFromError(err) {
    return { hasError: true, message: err?.message || 'Unbekannter Fehler' };
  }
  componentDidCatch(err, info) {
    console.error('[ErrorBoundary]', err, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
          height:'100vh', background:'#0f172a', color:'#e2e8f0', fontFamily:'sans-serif', padding:'24px', textAlign:'center' }}>
          <div style={{ fontSize:'48px', marginBottom:'16px' }}>⚠️</div>
          <h2 style={{ color:'#f87171', marginBottom:'8px' }}>Etwas ist schiefgelaufen</h2>
          <p style={{ color:'#94a3b8', marginBottom:'24px', maxWidth:'360px' }}>{this.state.message}</p>
          <button onClick={() => window.location.href = '/'}
            style={{ padding:'12px 24px', background:'#6366f1', color:'white', border:'none',
              borderRadius:'8px', fontSize:'15px', cursor:'pointer', fontWeight:'600' }}>
            Zurück zur Startseite
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App /></ErrorBoundary>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', {
        // Never use the HTTP cache when checking for SW updates.
        // Required so that iOS/Safari doesn't serve a stale sw.js from cache.
        updateViaCache: 'none',
      })
      .then(registration => {
        // Force an immediate check for a new SW on every page load.
        // Without this, browsers may delay update checks for up to 24 h.
        registration.update().catch(() => {});

        // When a new SW takes control (skipWaiting + clients.claim), reload
        // ONCE so the fresh index.html + new bundle are loaded.
        // sessionStorage guard prevents a reload loop across consecutive activations.
        let reloading = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (reloading) return;
          const KEY = 'vm-sw-reload';
          if (sessionStorage.getItem(KEY)) {
            sessionStorage.removeItem(KEY);
            return;
          }
          reloading = true;
          sessionStorage.setItem(KEY, '1');
          window.location.reload();
        });
      })
      .catch(() => {});
  });
}
